var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent, isValidElement } from 'react';
import { defaultProps } from './defaults';
import { LoadingOutlined } from '@feb-team/legao-icons-react';
import { DivTag } from '../../Utils/AtomicTag';
var Loading = /** @class */ (function (_super) {
    __extends(Loading, _super);
    function Loading(props) {
        return _super.call(this, props) || this;
    }
    // 是否是嵌套模式
    Loading.prototype.hasChildren = function () {
        return this.props && this.props.children;
    };
    Loading.prototype.renderIndicator = function (indicator, size) {
        // 渲染自定义标识符
        if (isValidElement(indicator)) {
            return React.cloneElement(indicator);
        }
        var sizeMap = {
            small: {
                default: {
                    sizeCls: ['w-4', 'h-4'],
                },
            },
            normal: {
                default: {
                    sizeCls: ['w-5', 'h-5'],
                },
            },
            large: {
                default: {
                    sizeCls: ['w-6', 'h-6'],
                },
            },
        };
        if (!sizeMap[size]) {
            size = 'normal';
        }
        return (React.createElement(LoadingOutlined, { spin: true, className: sizeMap[size].default.sizeCls.join(' ') + " legao-icon-loading" }));
    };
    Loading.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, style = _a.style, tip = _a.tip, wrapperClassName = _a.wrapperClassName, loading = _a.loading, children = _a.children, indicator = _a.indicator, size = _a.size, rest = __rest(_a, ["className", "style", "tip", "wrapperClassName", "loading", "children", "indicator", "size"]);
        var loadingCls = ['inline-flex', 'align-middle', 'flex-col'];
        var spinElement = function () { return (React.createElement(DivTag, __assign({ name: Loading.NAME, atomics: loadingCls, style: style, className: "" + className }, rest),
            _this.renderIndicator(indicator, size),
            tip ? React.createElement(DivTag, { atomics: ['text-brand-900'] }, tip) : null)); };
        if (this.hasChildren()) {
            var wrapperCls = ['relative', 'transition-opacity', 'duration-300'];
            loadingCls = loadingCls.concat([
                'absolute',
                'top-0',
                'left-0',
                'flex',
                'items-center',
                'justify-center',
                'z-10',
                'w-full',
                'h-full',
            ]);
            if (loading) {
                wrapperCls = wrapperCls.concat(['opacity-40']);
            }
            return (React.createElement(DivTag, __assign({ name: Loading.NAME, atomics: "relative", className: "" + wrapperClassName }, rest),
                loading && React.createElement("div", { key: "loading" }, spinElement()),
                React.createElement(DivTag, { atomics: wrapperCls }, children)));
        }
        return loading && spinElement();
    };
    Loading.defaultProps = defaultProps;
    Loading.NAME = 'loading';
    Loading.displayName = 'Loading';
    return Loading;
}(PureComponent));
export { Loading };
